export const PLAYER_EVENTS = {
    PLAYER_WAITING:'PLAYER_WAITING',
    PLAYER_RESUME:'PLAYER_RESUME'
}